/**
 * Resolves a static image path against the correct backend origin.
 * In MFE mode the app is embedded in a host at a different origin, so
 * bare /static/... paths would resolve against the host instead of our backend.
 * window.__OC_MFE_API_BASE__ is set by the MFE host to our backend origin.
 * `@param` {string} path - The image path to resolve (e.g., "/static/images/logo.png")
 * `@returns` {string} The fully resolved image path
 */
export function getImagePath(path) {
  if (!path) return path;
  const base = ((typeof window !== "undefined" && window.__OC_MFE_API_BASE__) || "").replace(
    /\/$/,
    ""
  );
  return base + path;
}
